import { AnchorsOfForms } from '@constants/forms'
import { useScrollTopTouchedForm } from '@shared/components/forms/new-loan/shared/hooks/use-scroll-top-touched-form'

import { View } from './view'

export const LoanFormSuccess = () => {
	useScrollTopTouchedForm(AnchorsOfForms.loanStepSuccess, { align: { topOffset: 90 } })
	return View()
}
